import PropTypes from 'prop-types';

// material
import { Grid } from '@mui/material';
import AerosMapCard from './AerosMapCard';

// ----------------------------------------------------------------------

AerosList.propTypes = {
  aeros: PropTypes.array
};

export default function AerosList({ aeros }) {
  return (
    <Grid container spacing={3}>
      {aeros.map((item) => (
        <Grid key={item.id} item xs={12} sm={6} md={3}>
          <AerosMapCard aero={item} />
        </Grid>
      ))}
    </Grid>
  );
}
